if (!customElements.get('rok-color-projects')) {
  customElements.define('rok-color-projects', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.loadProjects();
    }
    async loadProjects() {
      const status = this.querySelector('[data-project-status]');
      try {
        const url = new URL(this.dataset.url, location.origin);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Portfolio unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!doc.querySelector('rok-portfolio')) throw new Error('Portfolio unavailable');
        const cards = [...doc.querySelectorAll('[data-project]')].filter(card =>
          card.dataset.cabinetHandles?.split('|').includes(this.dataset.handle)
        );
        const grid = this.querySelector('[data-project-grid]');
        const fragment = document.createDocumentFragment();
        for (const card of cards) {
          const source = card.querySelector('.rkp__cover img');
          const title = card.querySelector('.rkp__caption h2')?.textContent;
          if (!source || !title) continue;
          const link = document.createElement('a');
          link.className = 'rok-color-projects__card';
          const target = new URL(url);
          target.searchParams.set('project', card.dataset.projectKey);
          link.href = target.pathname + target.search;
          const photo = document.createElement('img');
          photo.src = source.getAttribute('src');
          if (source.getAttribute('srcset')) photo.srcset = source.getAttribute('srcset');
          photo.sizes = '(min-width: 801px) 30vw, (min-width: 521px) 45vw, 90vw';
          photo.width = 800; photo.height = 600; photo.loading = 'lazy'; photo.alt = title;
          const caption = document.createElement('div');
          caption.className = 'rok-color-projects__caption';
          const heading = document.createElement('h3'); heading.textContent = title;
          const description = document.createElement('p');
          description.textContent = card.querySelector('.rkp__caption p')?.textContent || '';
          const cta = document.createElement('span'); cta.textContent = this.dataset.view + ' ↗';
          caption.append(heading, description, cta); link.append(photo, caption); fragment.append(link);
        }
        grid.replaceChildren(fragment);
        if (!grid.children.length) { status.textContent = this.dataset.empty; status.hidden = false; }
      } catch (error) {
        status.textContent = this.dataset.error; status.hidden = false;
      }
    }
  });
}
